export default __webpack_public_path__ + "static/media/Engage_Logo_Reverse.56e83539.svg";